import { SupplierCompanyMessage } from '../../types/SupplierCompanyMessage';
import { Switch } from '../cdl/Switch/Switch';
import { Text } from '../cdl/Text/Text';
import { translate } from '../common/helpers/translate.helper';
import { Box } from '../common/ui/Box';

import { MailSettings } from './components/MailSettings';
import { useSupplierAdminSettingsOptimisticMutation } from './hooks/useSupplierAdminSettingsOptimisticMutation';

interface SupplierAdminSettingsProps {
    companyDetails: SupplierCompanyMessage;
}

export const SupplierAdminSettings = ({ companyDetails }: SupplierAdminSettingsProps) => {
    const optimisticMutation = useSupplierAdminSettingsOptimisticMutation(companyDetails.id);

    const handleSettingChange = (newCompanyData: SupplierCompanyMessage) => {
        optimisticMutation.mutate({
            id: companyDetails.id,
            supplierData: newCompanyData,
        });
    };

    return (
        <Box display="flex" flexDirection="column" gap={24}>
            <Text variant="subtitle1" as="h2">
                {translate('company.adminSettings')}
            </Text>

            <Box display="flex" flexDirection="column" gap={16}>
                <Switch
                    label={translate('company.testCompany')}
                    checked={companyDetails.testCompany}
                    onChange={(checked) => handleSettingChange({ ...companyDetails, testCompany: checked })}
                />

                <Switch
                    label={translate('company.showGtc')}
                    checked={companyDetails.showGtc}
                    onChange={(checked) => handleSettingChange({ ...companyDetails, showGtc: checked })}
                />

                <Switch
                    label={translate('company.trial')}
                    checked={companyDetails.trial}
                    onChange={(checked) => handleSettingChange({ ...companyDetails, trial: checked })}
                />

                <MailSettings
                    mailSettings={companyDetails.mailSettings}
                    onSettingChange={(newMailSettings) =>
                        handleSettingChange({ ...companyDetails, mailSettings: newMailSettings })
                    }
                />
            </Box>
        </Box>
    );
};
